// extracted by mini-css-extract-plugin
module.exports = {"center":"BadRequest_center__3FW6G","errorCode":"BadRequest_errorCode__2otkU","errorDesc":"BadRequest_errorDesc__3ZF48"};